module.exports = __webpack_public_path__ + "static/media/social-worker.81e32664.jpg";